export enum ActionTypes {
  SET_ITEMS = 'APP/SET_ITEMS',
  SET_SELECTED_COMPONENT_GROUP = 'APP/SET_SELECTED_COMPONENT_GROUP',
}

export interface SetItemsAction {
  type: ActionTypes.SET_ITEMS;
  payload: object[];
}

export interface SetSelectedComponentGroupAction {
  type: ActionTypes.SET_SELECTED_COMPONENT_GROUP;
  payload: object;
}

export type AppActions = SetItemsAction | SetSelectedComponentGroupAction;
